import questionImage from "../../images/question-img.png";

// sample dummy data

export const questions = [
  {
    id: 1,
    questionText: "What is the capital of Nigeria?",
    hasImage: null,
    answerOptions: [
      { answerText: "Abuja ", isCorrect: true },
      { answerText: "Imo", isCorrect: false },
      { answerText: "Lagos ", isCorrect: false },
      { answerText: "Calabar ", isCorrect: false },
    ],
  },
  {
    id: 2,
    questionText: "Who betrayed Jesus?",
    hasImage: questionImage,
    answerOptions: [
      { answerText: "Devil", isCorrect: false },
      { answerText: "Satan", isCorrect: false },
      { answerText: "Herod", isCorrect: false },
      { answerText: "Judas", isCorrect: true },
    ],
  },
  {
    id: 3,
    questionText: "who is richest person in the world?",
    hasImage: null,
    answerOptions: [
      { answerText: "Jeff Bezos", isCorrect: false },
      { answerText: "Elon Musk", isCorrect: true },
      { answerText: "Bill Gates", isCorrect: false },
      { answerText: "Warren Buffett", isCorrect: false },
    ],
  },
  {
    id: 4,
    questionText: "Who is the president of Nigeria?",
    hasImage: questionImage,
    answerOptions: [
      { answerText: "Osibanjo", isCorrect: false },
      { answerText: "Rochas", isCorrect: false },
      { answerText: "Tinibu", isCorrect: false },
      { answerText: "Buhari", isCorrect: true },
    ],
  },
  {
    id: 5,
    questionText: "Who is the president of Nigeria?",
    hasImage: null,
    answerOptions: [
      { answerText: "Osibanjo", isCorrect: false },
      { answerText: "Rochas", isCorrect: false },
      { answerText: "Tinibu", isCorrect: false },
      { answerText: "Buhari", isCorrect: true },
    ],
  },
  {
    id: 6,
    questionText: "What is the capital of Nigeria?",
    hasImage: null,
    answerOptions: [
      { answerText: "Abuja ", isCorrect: true },
      { answerText: "Imo", isCorrect: false },
      { answerText: "Lagos ", isCorrect: false },
      { answerText: "Calabar ", isCorrect: false },
    ],
  },
  {
    id: 7,
    questionText: "Who betrayed Jesus?",
    hasImage: null,
    answerOptions: [
      { answerText: "Devil", isCorrect: false },
      { answerText: "Satan", isCorrect: false },
      { answerText: "Herod", isCorrect: false },
      { answerText: "Judas", isCorrect: true },
    ],
  },
];

// sample dummy data similar to proctorme api
export const loadingDummy = {
  question: "lioading...",
  options: ["lioading...", "lioading...", "lioading...", "lioading..."],
  answer: [],
  exam: "xxxxxxxxxxxxxxxxxxxx",
  numberOfAnswers: 1,
};

export const questions2 = [
  {
    question: "What is the capital of Nigeria",
    options: ["Abuja", "Lagos", "Imo", "40 40"],
    answer: "Abuja",
    exam: "61ee5f9f4bba3b001db6d7bc",
  },
  {
    question: "Who killed Jesus",
    options: ["Devil", "Satan", "Soldiers", "Judas Iscariot"],
    answer: "I don't know",
    exam: "61ee5f9f4bba3b001db6d7bc",
  },
  {
    question: "Who is the president of Nigeria",
    options: ["Bubu", "Buhari", "Burhamad", "Osibanjo"],
    answer: "Buhari",
    exam: "61ee5f9f4bba3b001db6d7bc",
  },
  {
    question: "What is the capital of Lagos",
    options: ["Lekki", "Apapa", "Ikeja", "Moshalashi"],
    answer: "Ikeja",
    exam: "61ee5f9f4bba3b001db6d7bc",
  },
];

const tempArray = ["Leo", 2, 2, 5, 6];
